import { render, staticRenderFns } from "./comsultationForm.vue?vue&type=template&id=40bedb41&scoped=true"
import script from "./comsultationForm.vue?vue&type=script&lang=js"
export * from "./comsultationForm.vue?vue&type=script&lang=js"
import style0 from "./comsultationForm.vue?vue&type=style&index=0&id=40bedb41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bedb41",
  null
  
)

export default component.exports